import { render, staticRenderFns } from "./CsAnimatedNumber.vue?vue&type=template&id=19768247&"
import script from "./CsAnimatedNumber.vue?vue&type=script&setup=true&lang=js&"
export * from "./CsAnimatedNumber.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports